import React from 'react';
import styled, { css } from 'styled-components';
import { Link as RouterLink } from '@reach/router';

const buttonSize = size => {
  switch (size) {
    case 'xl':
      return css`
        border-radius: 2em;
        padding: 0.25em 2em;
        font-size: 2em;
        display: flex;
        margin: 0 1em;

        @media ${({ theme }) => theme.device.m} {
          margin: 0;
          display: inline-flex;
          padding: 0.5em 4em;
        }
      `;
    case 'l':
      return css`
        border-radius: 1.5em;
        padding: 0.5em 2em;
        font-size: 1.5em;
      `;
    default:
    case 'normal':
      return css`
        border-radius: 1.2em;
        padding: 0.25em 1em;
        font-size: 1.2em;
      `;
  }
};

function buttonVariant({ block, size, theme, outline, empty }) {
  const styles = [];

  if (block) {
    styles.push(css`
      width: 100%;
    `);
  }

  styles.push(buttonSize(size));

  if (empty) {
    styles.push(css`
      background-color: transparent;
      color: ${({ theme }) => theme.colors.accentFg};
    `);
  }

  if (outline) {
    styles.push(css`
      background-color: transparent;
      color: ${({ theme }) => theme.colors.brand};
      border: 2px solid ${({ theme }) => theme.colors.brand};
      > svg {
        * {
          fill: ${({ theme }) => theme.colors.brand};
        }
      }
    `);
  }

  return styles;
}

const buttonBase = css`
  display: inline-flex;
  align-items: middle;
  justify-content: center;
  text-transform: lowercase;
  border: none;
  font-family: ${({
    theme: {
      fonts: { main },
    },
  }) => main};
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.accentFg};
  background-color: ${({ theme }) => theme.colors.brand};

  :active {
    transition: 0.1s ease-in-out all;
    transform: scale(0.95);
  }

  > svg {
    margin-right: 5px;
    * {
      fill: ${({ theme }) => theme.colors.accentFg};
    }
  }

  ${({ size, outline, block, empty, theme }) => buttonVariant({ outline, block, empty, theme, size })}
`;

const StyledButton = styled.button`
  ${buttonBase}
`;

const StyledAnchor = styled.a`
  ${buttonBase}
`;

const StyledLink = styled(RouterLink)`
  ${buttonBase}
`;

export default function Button(props) {
  if (props.href) {
    return <StyledAnchor {...props} role="button" />;
  }

  if (props.to) {
    return <StyledLink {...props} role="button" />;
  }

  return <StyledButton {...props} role="button" />;
}
